import { useConfiguration } from '~/context/common/StaticContext';
import { useUserLocation } from '~/context/common/UserContext';

export default function useGetIsInPriceDropRestrictedState() {
  const { priceDropRestrictedStates = [] } = useConfiguration();
  const { state } = useUserLocation();

  return priceDropRestrictedStates.includes(state);
}
